import axios from "axios";
const REACT_APP_ADMIN_API = process.env.REACT_APP_ADMIN_API;

export const getVehicles = async (query, page = 1, cancelToken) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");

  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/vehicle?db=${region}&q=${query}&results_per_page=60&page=${page}&expand_devices=false`,
      headers: { Authorization: `Bearer ${token}` },
      cancelToken,
    });
    return { data: response.data, hasNextPage: response.data.has_next_page };
  } catch (e) {
    return { e };
  }
};

export const getVehicle = async (vehicleId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "get",
      url: `${REACT_APP_ADMIN_API}/api/vehicle/${vehicleId}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { details: e.response.data };
  }
};

export const createVehicle = async (
  customer,
  vehicleName,
  device1,
  device2,
  active,
  apiFetch,
  apiPush,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "post",
      url: `${REACT_APP_ADMIN_API}/api/customer/${customer}/vehicle?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ...{
          name: vehicleName,
          customer: customer,
          active: active,
          api_fetch: apiFetch,
          api_push: apiPush,
          imei: device1,
        },
        ...(device2 && { device_2: device2 }),
      },
    });
    return { data: response };
  } catch (e) {
    if (
      e.response.data.code === 33 &&
      e.response.data.error === "invalid imei"
    ) {
      return { errors: { device1: "Invalid IMEI" } };
    } else if (
      e.response.data.code === 33 &&
      e.response.data.error === "invalid device_2 imei"
    ) {
      return { errors: { device2: "Invalid IMEI" } };
    }
    return { details: e.response.data.error };
  }
};

export const updateVehicle = async (
  customer,
  vehicleId,
  vehicleName,
  device1,
  device2,
  active,
  apiFetch,
  apiPush,
  vehicleParameters,
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "put",
      url: `${REACT_APP_ADMIN_API}/api/vehicle/${vehicleId}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        ...{
          customer: customer,
          name: vehicleName,
          active: active,
          api_fetch: apiFetch,
          api_push: apiPush,
          imei: device1,
          device_2: device2,
          vehicle_params: vehicleParameters,
        },
      },
    });
    return { data: response.data };
  } catch (e) {
    return { e };
  }
};

export const deleteVehicle = async (vehicleId) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  const region = localStorage.getItem("region");
  try {
    const response = await axios({
      method: "delete",
      url: `${REACT_APP_ADMIN_API}/api/vehicle/${vehicleId}?db=${region}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    return { data: response.data };
  } catch (e) {
    return { detail: e.response.data.error };
  }
};